import { Box, styled } from '@mui/material';
import classNames from 'classnames';

import { EFlightCategory } from '#shared';

const PREFIX = 'TSMED-WindLegend';
const windLegendClasses = {
  group: `${PREFIX}-group`,
  item: `${PREFIX}-item`,
  airportIcon: `${PREFIX}-airportIcon`,
  label: `${PREFIX}-label`,
  aircraftIcon: `${PREFIX}-aircraftIcon`,
};

const Root = styled(Box)(({ theme: { spacing, palette } }) => ({
  display: 'flex',
  alignItems: 'center',
  color: palette.grey[700],
  borderRadius: spacing(1.5),
  background: 'rgba(0, 0, 0, 0.30)',
  gap: spacing(3),
  [`.${windLegendClasses.item}`]: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing(1),
    [`.${windLegendClasses.airportIcon}`]: {
      width: 16,
      height: 16,
      borderRadius: '50%',
      color: palette.grey[700],
      border: `5px solid`,
      borderColor: 'currentColor',
      [`&.flight-category-${EFlightCategory.LIFR}`]: {
        color: palette.flightCategory.LIFR,
      },
      [`&.flight-category-${EFlightCategory.IFR}`]: {
        color: palette.flightCategory.IFR,
      },
      [`&.flight-category-${EFlightCategory.MVFR}`]: {
        color: palette.flightCategory.MVFR,
      },
      [`&.flight-category-${EFlightCategory.VFR}`]: {
        color: palette.flightCategory.VFR,
      },
    },
  },
}));
export const FlightCategoryLegend = () => (
  <Root>
    <Box className={classNames(windLegendClasses.item)}>
      <Box
        className={classNames(
          windLegendClasses.airportIcon,
          `flight-category-${EFlightCategory.VFR}`,
        )}
      />
      <Box className={classNames(windLegendClasses.label)}>
        {EFlightCategory.VFR}
      </Box>
    </Box>
    <Box className={classNames(windLegendClasses.item)}>
      <Box
        className={classNames(
          windLegendClasses.airportIcon,
          `flight-category-${EFlightCategory.MVFR}`,
        )}
      />
      <Box className={classNames(windLegendClasses.label)}>
        {EFlightCategory.MVFR}
      </Box>
    </Box>
    <Box className={classNames(windLegendClasses.item)}>
      <Box
        className={classNames(
          windLegendClasses.airportIcon,
          `flight-category-${EFlightCategory.IFR}`,
        )}
      />
      <Box className={classNames(windLegendClasses.label)}>
        {EFlightCategory.IFR}
      </Box>
    </Box>
    <Box className={classNames(windLegendClasses.item)}>
      <Box
        className={classNames(
          windLegendClasses.airportIcon,
          `flight-category-${EFlightCategory.LIFR}`,
        )}
      />
      <Box className={classNames(windLegendClasses.label)}>
        {EFlightCategory.LIFR}
      </Box>
    </Box>
    <Box className={classNames(windLegendClasses.item)}>
      <Box className={classNames(windLegendClasses.airportIcon)} />
      <Box className={classNames(windLegendClasses.label)}>No Data</Box>
    </Box>
  </Root>
);
